const BASE_URL = process.env.VUE_APP_API_GW_URL

// Shared request builder: applies CORS/cache defaults and the bearer token.
function buildRequest(params = {}) {
  params = Object.assign({
    mode: 'cors',
    cache: 'no-cache',
  }, params)

  let token = localStorage.getItem('accessToken')

  params.headers = Object.assign({
    Authorization: `${token}`
  }, params.headers)

  return params
}

export async function api(url, params = {}) {
  let response = await fetch(BASE_URL + url, buildRequest(params))
  let json = await response.json() || {}
  if (!response.ok) {
    let errorMessage = json.error || response.status
    throw new Error(errorMessage)
  }
  return json
}

// Same contract as api(), but returns the raw response body as text. Used for
// the CSV export, where parsing the body as JSON would throw.
export async function apiText(url, params = {}) {
  let response = await fetch(BASE_URL + url, buildRequest(params))
  let text = await response.text()
  if (!response.ok) {
    // Error responses are JSON even on the CSV endpoints; surface the message.
    let errorMessage = response.status
    try {
      errorMessage = (JSON.parse(text).error) || response.status
    } catch (e) {
      // Body was not JSON; fall back to the status code.
    }
    throw new Error(errorMessage)
  }
  return text
}
